export function nowIso(): string {
  return new Date().toISOString();
}

export function serverTimestamp(record: Record<string, unknown>): string {
  const updatedAt = record.updatedAt;
  if (typeof updatedAt === 'string') return updatedAt;

  const completedAt = record.completedAt;
  if (typeof completedAt === 'string') return completedAt;

  const createdAt = record.createdAt;
  if (typeof createdAt === 'string') return createdAt;

  const date = record.date;
  if (typeof date === 'string') return date;

  return new Date(0).toISOString();
}

export function isLocalNewer(localUpdatedAt: string, serverRecord: Record<string, unknown>): boolean {
  return new Date(localUpdatedAt).getTime() > new Date(serverTimestamp(serverRecord)).getTime();
}

export function generateTempId(): string {
  return `offline_${crypto.randomUUID()}`;
}
